ACC.negotiatequote = {

  bindAll: function() {
    if (typeof cartDataquoteAllowed !== 'undefined') {
      /* eslint-disable  no-undef */
      $('#requestQuoteButton').attr('quoteAllowed', cartDataquoteAllowed);
      /* eslint-enable  no-undef */
      this.bindToCancelQuoteClick();
      this.updateRequestQuoteButton();
      this.bindToProceedButtonClick();
      this.bindToRequestQuoteButtonClick();
    }
  },

  displayNegotiateQuoteDiv: function() {
    $('#requestQuoteButton').addClass('pressed');
    $('#negotiate-quote-div').show();
    $('.place-order').attr('disabled', true);
    $('#scheduleReplenishmentButton').attr('disabled', true);

    return false;
  },

  bindToCancelQuoteClick: function() {
    $('#cancel-quote-negotiation').click(function() {
      ACC.negotiatequote.cancelQuoteNegotiationEvent();
    });
  },

  cancelQuoteNegotiationEvent: function() {
    $('#requestQuoteButton').removeClass('pressed');
    $('#negotiate-quote-div').hide();
    $('#quoteRequestDescription').value = '';
    $('#negotiateQuote').val(false);
    ACC.placeorder.updatePlaceOrderButton();
    ACC.negotiatequote.updateRequestQuoteButton();
    ACC.replenishment.updateScheduleReplenishmentButton();
  },

  bindToProceedButtonClick: function() {
    $('#negotiateQuoteButton').click(function() {
      $('#negotiateQuote').val(true);
      ACC.placeorder.placeOrderWithSecurityCode();

      return false;
    });
  },

  bindToRequestQuoteButtonClick: function() {
    $('#requestQuoteButton').click(function() {
      $('#requestQuoteButton').addClass('pressed');

      ACC.negotiatequote.displayNegotiateQuoteDiv();

      return false;
    });
  },

  bindToUpdateRequest: function() {
    var $itemContainerHolder = $('#checkout_summary_costcenter_div .ph-costcenter');

    if ($itemContainerHolder.find('div').hasClass('ph-checkoutcost-center__wrapper') && $itemContainerHolder.find('select').length === 1) {
      return $('#CostCenter option:selected')[0].value !== '';
    }

    if ($('#requestQuoteButton').hasClass('pressed')) {
      $('.place-order').attr('disabled', true);
      $('#scheduleReplenishmentButton').attr('disabled', true);
    }

    return false;
  },

  updateRequestQuoteButton: function() {
    var paymentType = $('#checkout_summary_paymentType_div').hasClass('complete');
    var deliveryAddress = $('#checkout_summary_deliveryaddress_div').hasClass('complete');
    var deliveryMode = $('#checkout_summary_deliverymode_div').hasClass('complete');
    var costCenter = $('#checkout_summary_costcenter_div').hasClass('complete');
    var paymentDetails = $('#checkout_summary_payment_div').hasClass('complete');
    var selectedPaymentType = $('input:radio[name=\'PaymentType\']:checked').val() !== 'CARD';
    var quoteAllowed = $('#requestQuoteButton').attr('quoteAllowed') === 'true';

    var costCenterValue = false;

    costCenterValue = ACC.negotiatequote.bindToUpdateRequest();

    if ((quoteAllowed && paymentType) && (deliveryAddress && costCenterValue)) {
      if (deliveryMode && (costCenter || paymentDetails) && selectedPaymentType) {
        $('#requestQuoteButton').removeAttr('disabled');
      }
    } else {
      $('#requestQuoteButton').attr('disabled', true);
    }
  }

};

$(document).ready(function() {
  /* eslint-disable  no-undef */
  if (typeof negotiateQuote !== 'undefined' && negotiateQuote) {
    /* eslint-enable  no-undef */
    ACC.negotiatequote.displayNegotiateQuoteDiv();

    // Used in Account Quote Management page
    $('#negotiate-quote-div-label-add-comment').show();
  }

  ACC.negotiatequote.bindAll();
});


